import { CellProps } from 'hooks/useMuiTableBuilderV2';
import { Realm } from 'types';
import { SandboxTableHeadCellIds, cellRenderer } from 'SandboxModule/components/sharedTableConfigs';

export type RealmRowData = Realm & {
  checkedSandboxes?: Set<string>;
  setCheckedSandboxesSet?: React.Dispatch<React.SetStateAction<Set<string>>>;
};

export const createRealmDataCell =
  (id: SandboxTableHeadCellIds) =>
  (props: CellProps<RealmRowData>): JSX.Element | null => {
    const { _customRowProps, ...rest } = props;
    const mergedData: RealmRowData = {
      ...(rest as unknown as RealmRowData),
      ...(_customRowProps as Partial<RealmRowData>),
    };

    const rendererMap: Record<
      keyof typeof SandboxTableHeadCellIds | string,
      (data: RealmRowData) => JSX.Element | null
    > = cellRenderer as unknown as Record<string, (data: RealmRowData) => JSX.Element | null>;
    const renderer = rendererMap[id];
    return renderer ? renderer(mergedData) : null;
  };
